<template>
  <div :class="['c-nav-toggle', { 'c-nav-toggle--open': isMenuOpen }]" @click.stop="toggle">
    <div class="c-nav-toggle__icon">
      <span></span>
      <span></span>
      <span></span>
    </div>
    <div class="c-nav-toggle__text">
      Menu
    </div>
    <div class="c-nav-toggle__notification" v-if="hasUnreadNotifications"></div>
  </div>
</template>

<script>
import { menu } from '@/mixins/helpers'

export default {
  name: 'SideNavBurger',

  mixins: [ menu ],

  computed: {
    hasUnreadNotifications () {
      return this.$store.state.notifications.totalUnreadCount > 0
    }
  }
}
</script>
